import { render, staticRenderFns } from "./safety-inventory-set.vue?vue&type=template&id=0b456b26&scoped=true&"
import script from "./safety-inventory-set.vue?vue&type=script&lang=ts&"
export * from "./safety-inventory-set.vue?vue&type=script&lang=ts&"
import style0 from "./safety-inventory-set.vue?vue&type=style&index=0&id=0b456b26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b456b26",
  null
  
)

export default component.exports